import React from 'react';
import colors from '../../theme/foundations/colors';
import { tqc } from '../../system';
import { Box } from '../layout';
export var StyledContainer = tqc('div', {
  baseStyle: {
    display: 'flex'
  }
});
export var StyledCount = props => {
  var getBackgroundColor = (count, maxCount) => {
    var max = maxCount || 99;
    if (count > max) {
      return colors.red[700];
    }
    return colors.blue[600];
  };
  var getWidth = count => {
    if (count > 9) {
      return '2rem';
    }
    return '1.25rem';
  };
  var getTransform = _ref => {
    var {
      rect,
      xOffset,
      yOffset,
      alignment
    } = _ref;
    var width = (rect === null || rect === void 0 ? void 0 : rect.width) || 0;
    var x = xOffset || 0;
    var y = yOffset || 0;

    // If we are left, just translate by the offset
    if (alignment === 'left') {
      return "translate(".concat(x, "px, ").concat(y, "px)");
    }
    return "translate(".concat(width + x, "px, ").concat(y, "px)");
  };
  return /*#__PURE__*/React.createElement(Box, {
    color: "white",
    borderRadius: "5rem",
    height: "1.25rem",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    fontWeight: "bold",
    border: "2px solid white",
    width: getWidth(props.count),
    backgroundColor: getBackgroundColor(props.count, props.maxCount),
    transform: getTransform(props),
    "data-testid": "count"
  }, props.children);
};